import { Network, TokenAsset } from '@types';
import { getTokenAssetNetworkPair } from '@lib/utils';

function useFilteredTokenAssets(
  tokenAssets: TokenAsset[],
  fromNetwork: Network,
  toNetwork: Network,
  query: string
): TokenAsset[] {
  return tokenAssets.filter(({ name, supportedNetworkPairs, symbol }) => {
    const networkPair = getTokenAssetNetworkPair(fromNetwork, toNetwork);
    const isSupported = supportedNetworkPairs.includes(networkPair);

    if (isSupported && query) {
      const lowerCaseQuery = query.toLowerCase();

      // TODO - Implement fuzzy-searching
      return (
        name.toLowerCase().includes(lowerCaseQuery) ||
        symbol.toLowerCase().includes(lowerCaseQuery)
      );
    }

    return isSupported;
  });
}

export default useFilteredTokenAssets;
